// LOGIN screen. Calls POST /api/auth/login; degrades to a clear message offline.
// Visual furniture (backdrop, Theo, field chrome) is shared with register.ts
// via ui/authVisuals so the two screens can never drift apart.
import {
  authBackdropHTML,
  authField,
  theoStageHTML,
  ICON_EMAIL,
  ICON_LOCK,
} from '../ui/authVisuals';

export const loginHTML = /* html */ `
<div id="screenLogin" class="authscreen hidden">
  ${authBackdropHTML}
  <div class="auth-top">
    <button class="icon-btn back" id="loginBackBtn" type="button" aria-label="Back">
      <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false" fill="currentColor"><path d="M11.7 4.3a1.2 1.2 0 0 1 0 1.7L7.7 10l4 4a1.2 1.2 0 1 1-1.7 1.7l-4.8-4.8a1.2 1.2 0 0 1 0-1.7L10 4.3a1.2 1.2 0 0 1 1.7 0Z"/></svg>
    </button>
  </div>

  ${theoStageHTML('Welcome back, my friend.')}

  <div class="hero">
    <div class="title">Welcome back</div>
    <div class="tagline">Sign in to sync your progress.</div>
  </div>

  <form class="auth-form auth-card" id="loginForm" novalidate>
    ${authField({
      id: 'loginEmail',
      label: 'Email',
      icon: ICON_EMAIL,
      inputHTML:
        '<input type="email" id="loginEmail" name="email" autocomplete="email" inputmode="email" placeholder="you@example.com" required />',
    })}
    ${authField({
      id: 'loginPassword',
      label: 'Password',
      icon: ICON_LOCK,
      inputHTML:
        '<input type="password" id="loginPassword" name="password" autocomplete="current-password" placeholder="Your password" required />',
      pwToggleId: 'loginPwToggle',
    })}
    <div class="auth-msg" id="loginMsg"></div>
    <button class="btn" type="submit" id="loginSubmit">Sign In</button>
    <div class="auth-alt">No account yet? <button type="button" id="loginToRegister">Create one</button></div>
    <div class="auth-alt"><button type="button" id="loginAsGuest">Continue as guest</button></div>
  </form>
</div>`;
